import axios from 'axios';

const API_BASE_URL = '/api/v1/feature_flags/';

const get = (endpoint, params = {}) => {
  return new Promise((resolve, reject) => {
    const url = API_BASE_URL + endpoint;
    axios.get(url, { params })
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const featureFlag = (featureName, params) => {
  return get(encodeURIComponent(featureName), params);
};
